import React from 'react';
import { useBackendApi } from '../../../helpers/backendHelper';
import { trackClairtyEvent } from '../../../utils';
import { Flexbox, FlexboxColumn } from '../../action/Flexbox';
import Tooltip from '../../action/TooltipWrapper';
import ThemeLogo from '../../theme/ThemeLogo';
import ThemedText from '../../theme/ThemedText';
import './Reactions.scss';

const Reactions = ({ postData, handlePostData, eligible }) => {
  const backendHelper = useBackendApi();

  const total = Number(postData?.likes || 0) + Number(postData?.dislikes || 0);
  const likePercent = total > 0 ? (postData.likes / total) * 100 : 0;
  const dislikePercent = total > 0 ? (postData?.dislikes / total) * 100 : 0;

  async function postReaction(reaction) {
    try {
      trackClairtyEvent('engage', reaction);
      const body = {
        postId: postData?.postId,
        reaction: reaction,
      };

      const response = await backendHelper.reviews.postReaction(body);
      handlePostData(response?.data?.updatedPost);
    } catch (error) {
      console.log('Error in posting reaction');
    }
  }

  function handleReaction(key) {
    if (postData?.userReaction === key) return;

    handlePostData(state => {
      if (key === 'agree') {
        state['likes'] = Number(postData?.likes) + 1;
      } else {
        state['dislikes'] = Number(postData?.dislikes) + 1;
      }
      if (postData?.userReaction) {
        if (postData?.userReaction === 'agree') {
          state['likes'] = Math.max(Number(postData?.likes) - 1, 0);
        } else {
          state['dislikes'] = Math.max(Number(postData?.dislikes) - 1, 0);
        }
      }
      state['userReaction'] = key;
    });

    postReaction(key);
  }
  if (!eligible)
    return (
      <FlexboxColumn className='reviewcard_wrapper_noteligible' gap='0.5rem' fw>
        <Flexbox justifyContent='space-between' fw>
          <Flexbox gap='0.25em'>
            <ThemeLogo icon={'lock'} className='icon' />
            <ThemedText.H6>You’re not eligible to engage with this post</ThemedText.H6>
          </Flexbox>
          <Tooltip
            content={
              "We've limited your engagement to reviews of those projects where you have certain onchain activity. This for everyone ensures only the people who've interacted with certain dapps can engage or post about them."
            }
            position={'left'}
          >
            <ThemedText.H6 className='learn_more_text'>Learn More</ThemedText.H6>
          </Tooltip>
        </Flexbox>
        {total > 0 && (
          <Flexbox
            className='reaction_segment'
            justifyContent='space-between'
            style={{
              background: `linear-gradient(to right, var(--like-fill-color) ${likePercent}%, var(--dislike-fill-color) ${likePercent}%)`,
            }}
          >
            <ThemedText.H6 color='color-normal'>
              Support
              <ThemedText.Span color='color-light'>
                {' '}
                {likePercent.toFixed(0)}% ({postData?.likes || 0})
              </ThemedText.Span>
            </ThemedText.H6>
            <ThemedText.H6 color='color-normal'>
              Oppose
              <ThemedText.Span color='color-light'>
                {' '}
                {dislikePercent.toFixed(0)}% ({postData?.dislikes || 0})
              </ThemedText.Span>
            </ThemedText.H6>
            {/* <div className='reaction_segment support' style={{ flex: postData.likes }}>
            <strong>Support</strong> {likePercent.toFixed(0)}% ({postData?.likes || 0})
          </div>
          <div className='reaction_segment oppose' style={{ flex: postData.dislikes }}>
            <strong>Oppose</strong> {dislikePercent.toFixed(0)}% ({postData?.dislikes || 0})
          </div> */}
          </Flexbox>
        )}
      </FlexboxColumn>
    );
  return (
    <Flexbox fw gap='0.75rem' className='reactions_wrapper'>
      <Flexbox
        onClick={() => handleReaction('agree')}
        className={`reactions_wrapper_each reactions_wrapper_like ${postData?.userReaction === 'agree' && 'reactions_wrapper_like_active'}`}
        justifyContent='space-between'
        // style={
        //   postData?.userReaction && {
        //     background: `linear-gradient(to right, var(--like-fill-color) ${likePercent}%, var(--like-bg-color) ${likePercent}%)`,
        //   }
        // }
      >
        <Flexbox gap='0.25rem'>
          <ThemeLogo icon={'like'} />
          <ThemedText.H6 weight='medium'>Support</ThemedText.H6>
        </Flexbox>
        <ThemedText.H6 color='var(--like-fill-color)'>
          {likePercent.toFixed(0)}% ({postData?.likes || 0})
        </ThemedText.H6>
      </Flexbox>
      <Flexbox
        onClick={() => handleReaction('fud')}
        className={`reactions_wrapper_each reactions_wrapper_dislike ${postData?.userReaction === 'fud' && 'reactions_wrapper_dislike_active'}`}
        justifyContent='space-between'
        // style={
        //   postData?.userReaction && {
        //     background: `linear-gradient(to right, var(--dislike-fill-color) ${dislikePercent}%, var(--dislike-bg-color) ${dislikePercent}%)`,
        //   }
        // }
      >
        <Flexbox gap='0.25rem'>
          <ThemeLogo icon={'dislike'} />
          <ThemedText.H6 weight='medium'>Oppose</ThemedText.H6>
        </Flexbox>
        <ThemedText.H6 color='var(--dislike-fill-color)'>
          {dislikePercent.toFixed(0)}% ({postData?.dislikes || 0})
        </ThemedText.H6>
      </Flexbox>
    </Flexbox>
  );
};

export default Reactions;
